export const CONSTANTS = {
  SCREEN_GROUP: 'facility',
  LIST_ALL: 'list-facility-all',
  LIST_FACILITY_DICT: 'list-facility-dict',
  GRID_FACILITY_LOOKUP_DIALOG: 'grid-facility-lookup-dialog',
} as const;
